/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolLockIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-lock"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M5.9 23.1Q4.78 23.1 4.01 22.34Q3.25 21.57 3.25 20.45L3.25 10.25Q3.25 9.13 4.01 8.36Q4.78 7.6 5.9 7.6L6.3 7.6L6.3 5.6Q6.3 3.2 7.96 1.52Q9.63 -0.15 12 -0.15Q14.38 -0.15 16.04 1.52Q17.7 3.2 17.7 5.6L17.7 7.6L18.1 7.6Q19.23 7.6 19.99 8.36Q20.75 9.13 20.75 10.25L20.75 20.45Q20.75 21.57 19.99 22.34Q19.23 23.1 18.1 23.1ZM12 17.75Q12 17.75 12.49 17.75Q12.97 17.75 13.66 17.06Q14.35 16.38 14.35 15.4Q14.35 14.43 13.66 13.74Q12.97 13.05 12 13.05Q11.03 13.05 10.34 13.74Q9.65 14.43 9.65 15.4Q9.65 16.38 10.34 17.06Q11.03 17.75 12 17.75ZM8.95 7.6L15.05 7.6L15.05 5.6Q15.05 4.33 14.16 3.41Q13.28 2.5 12 2.5Q10.72 2.5 9.84 3.41Q8.95 4.33 8.95 5.6Z" fill={color} />
    </svg>
  );
}
